import { render, staticRenderFns } from "./settlementFormer.vue?vue&type=template&id=22d3185a&"
import script from "./settlementFormer.vue?vue&type=script&lang=js&"
export * from "./settlementFormer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports